import React, { Component } from "react";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import dynamicPortal from "../utils/dynamicPortal";
import connection from "../api/config/connection";

export class FormPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-form", (config, node) => {
      if (!config || !config.submit || !config.submit.action) {
        console.error(
          'React Form error: Provide at least a data-config attribute with a json object in the format {"steps":[], "submit": {"action": "/action"}}',
          node
        );
        return null;
      }

      return (
        <Form
          config={config}
          templates={templates}
          axios={connection.instance()}
          //onSubmitted={async (response, values) =>
          //  await window[config.submit.onSubmitted](response, values)
          //}
        />
      );
    });
  }

  // async handleSubmitted(response, values) {
  //   console.log('submitted handling...', response, values)
  //   await setTimeout(() => {
  //     console.log('submitted handled')
  //   }, 5000)
  // }
}

export default FormPortal;



// WEBPACK FOOTER //
// ./src/portals/FormPortal.js